import imageUpload from '../../assets/icons/plus.png';
import '../../assets/styles/pages.scss'
import { Link, useMatch, useNavigate } from 'react-router-dom'
import { Fragment, useContext, useEffect, useState } from 'react';
import henceforthApi from '../../utils/henceforthApi';
import { GlobalContext, handleError } from '../../context/Provider';
import Spinner from '../../components/common/spinner';
import { documentId, formValidate, NumberValidation } from '../../utils/validations';
import Errormessage from '../../components/common/errormessage';
import BreadCrumb from '../../components/common/BreadCrumb';
import { editBrandListing, editProductData, subLists } from './productInterface';
import Input, { SaveCancelButton } from '../../components/common/Inputs';
import Select from '../../components/common/Select';
import commonArray from '../../components/common/commonArray';
import Textarea from '../../components/common/Textarea';
import Inputs from '../../components/common/Inputs';
import { toast } from 'react-toastify';
import SignedImage from '../../components/common/SignedImage';


const EditProduct = () => {
    const { authState, authDispatch, language_data, loading, setLoading, toastMessage } = useContext(GlobalContext);
    const match = useMatch('/product/:id/edit')
    const navigate = useNavigate()

    let breadCrumbPath = [
        { name: ` ${language_data?.[authState.lang]?.common_home}`, url: `/`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_list}`, url: `/products/1`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_deatil}`, url: `/product/${match?.params.id}`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_edit} ${language_data?.[authState.lang]?.common_product}`, url: ``, active: 'not-allowed' }
    ]



    const [nameErr, setNameErr] = useState<string>("")
    const [brandErr, setBrandErr] = useState<string>("")
    const [priceErr, setPriceErr] = useState<string>("")
    const [taxErr, setTaxErr] = useState<string>("")
    const [categoryErr, setCategoryErr] = useState<string>("")
    const [pageLoading, setPageLoading] = useState<boolean>(false)
    const [descriptionErr, setDescriptionErr] = useState<string>("")
    const [subCategoryErr, setSubcategoryErr] = useState<string>("")
    const [selectedFileErr, setSelectedFileErr] = useState<string>('')
    const [subCategory, setSubCategory] = useState<Array<subLists>>([])
    const [subSubCategory, setSubSubCategory] = useState<Array<subLists>>([])
    const [selectedFile, setSelectedFile] = useState<Array<Blob | MediaSource>>([])
    const [brandDetails, setBrandDetails] = useState({
        brand: [],
        category: [],
    } as editBrandListing)
    // parcel: [],
    const [variantType, setVariantType] = useState('');
    const [variantValue, setVariantValue] = useState('');
    const [variantLabel, setVariantLabel] = useState('');
    const [variantErr, setVariantErr] = useState('');
    const [editProduct, setEditProduct] = useState({
        name: '',
        description: '',
        brand_id: '',
        category_id: '',
        subcategory_id: '',
        sub_subcategory_id: '',
        images: [],
        tax_percentage: '',
        price: '',
        discount_percantage: '',
        sold: false,
        is_blocked: false,
        is_deleted: false,
        language: ''
    } as editProductData);
    const brandListing = async () => {
        try {
            let apiBrandRes = (await henceforthApi.categorylisting.Brandlisting()).data.data;
            let apiCategoryRes = (await henceforthApi.categorylisting.categorylisting()).data.data;
            setBrandDetails({
                ...brandDetails,
                brand: apiBrandRes,
                category: apiCategoryRes,
            });
        } catch (err) {
            handleError(err, '', authDispatch);
            console.log(err);
        }
    };
    useEffect(() => {
        brandListing();
    }, []);
    const subListing = async () => {
        try {
            let apiSubCategoryRes = (await henceforthApi.categorylisting.subCategorylisting(editProduct.category_id
            )).data.data;
            setSubCategory(apiSubCategoryRes)
        } catch (err) {
            handleError(err, '', authDispatch);
            console.log(err);

        }
    }
    const sub_subListing = async () => {
        let apiSubSubCategoryRes = (await henceforthApi.categorylisting.subSubCategorylisting(editProduct.subcategory_id)).data.data;

        setSubSubCategory(apiSubSubCategoryRes)
    }
    useEffect(() => {
        if ((editProduct.category_id ?? '') !== "") {
            subListing()
        }
    }, [editProduct.category_id])
    useEffect(() => {
        if ((editProduct.subcategory_id ?? '') !== "") {
            sub_subListing()
        }
    }, [editProduct.subcategory_id])
    const handleFile = async (e: any) => {
        let files = e.target.files as Array<Blob | MediaSource>
        setSelectedFile([...selectedFile, ...files])
        e.target.value = ""
    };
    const clearInputErr = (name: string) => {
        if (name === 'name') setNameErr('')
        if (name === 'description') setDescriptionErr('')
        if (name === 'brand_id') setBrandErr('')
        if (name === 'category_id') setCategoryErr('')
        // if (name === 'category_id'&& categoryErr) setEditProduct((editProduct) => {return {...editProduct,subcategory_id: '',}});
        if (name === 'subcategory_id') setSubcategoryErr('')
        // if (name === 'subcategory_id' && subCategoryErr) setEditProduct((editProduct) => {return {...editProduct,subcategory_id: '',}});
        // if (name === 'subcategory_id') setCategoryErr('')
        if (name === 'tax_percentage') setTaxErr('')
        if (name === 'price') setPriceErr('')
    }
    const handleChange = (e: any) => {
        let name = e.target.name;
        let value = e.target.value;
        clearInputErr(name)
        let res = formValidate(name, value)
        if (res === false) return
        if (name === 'category_id' && !value) setEditProduct((editProduct) => { return { ...editProduct, subcategory_id: '', sub_subcategory_id: '' } });
        if (name === 'subcategory_id' && !value) setEditProduct((editProduct) => { return { ...editProduct, sub_subcategory_id: '', } });
        setEditProduct((editProduct) => {
            return {
                ...editProduct,
                [name]: value,
            }
        });
    };
    const uploadImages = async () => {
        const images = [] as Array<string>
        await Promise.all(selectedFile.map(async (res) => {
            try {
                const apiRes = await henceforthApi.Common.do_spaces_file_upload(`file`, res)
                const data = apiRes.data
                images.push(data.file_name)
            } catch (err) {
                handleError(err, 'active', authDispatch);
                console.log(err);
            }
        }
        ))
        return images
    }
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!selectedFile.length && !editProduct.name && !editProduct.description && !editProduct.tax_percentage && !editProduct.brand_id && !editProduct.category_id && !editProduct.subcategory_id && !editProduct.price) {
            setSelectedFileErr(`${language_data?.[authState.lang]?.common_image}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setNameErr(`${language_data?.[authState.lang]?.common_name}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setDescriptionErr(`${language_data?.[authState.lang]?.common_description}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setBrandErr(`${language_data?.[authState.lang]?.common_brand}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setTaxErr(`${language_data?.[authState.lang]?.common_tax}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setCategoryErr(`${language_data?.[authState.lang]?.common_category}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setSubcategoryErr(`${language_data?.[authState.lang]?.common_sub_category}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            // setQuantityErr(`${language_data?.[authState.lang]?.common_quantity}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setPriceErr(`${language_data?.[authState.lang]?.common_price}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            return
        }
        if (selectedFile.length === 0 && editProduct.images.length === 0) { setSelectedFileErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_image}`); documentId('images'); return }
        if (!editProduct.name.trim()) { documentId('productName'); setNameErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_provide}${language_data?.[authState.lang]?.common_name}`); return }
        if (!editProduct.description.trim()) { documentId('description'); setDescriptionErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_provide}${language_data?.[authState.lang]?.common_description}`); return }
        if (!editProduct.price) { documentId('price'); setPriceErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_add}${language_data?.[authState.lang]?.common_price}`); return }
        if (!Number(editProduct.price)) { documentId('price'); setPriceErr(`${language_data?.[authState.lang]?.common_only} ${language_data?.[authState.lang]?.common_use} ${language_data?.[authState.lang]?.common_number}${language_data?.[authState.lang]?.common_in}${language_data?.[authState.lang]?.common_price}`); return }
        if (editProduct.tax_percentage === '' || editProduct.tax_percentage === null || editProduct.tax_percentage === undefined) { documentId('tax_percentage'); setTaxErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_add}${language_data?.[authState.lang]?.common_tax}`); return }
        if (editProduct.tax_percentage !== '' && isNaN(Number(editProduct.tax_percentage))) { documentId('tax_percentage'); setTaxErr(`${language_data?.[authState.lang]?.common_only}${language_data?.[authState.lang]?.common_use}${language_data?.[authState.lang]?.common_number}${language_data?.[authState.lang]?.common_in}${language_data?.[authState.lang]?.common_tax}`); return }
        // if (!Number(editProduct.quantity)) { documentId('quantity'); setQuantityErr(`${language_data?.[authState.lang]?.common_only}${language_data?.[authState.lang]?.common_use}${language_data?.[authState.lang]?.common_number}${language_data?.[authState.lang]?.common_in}${language_data?.[authState.lang]?.common_quantity}`); return }
        if (!editProduct.brand_id.trim()) { documentId('brand_id'); setBrandErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_brand}`); return }
        if (!editProduct.category_id.trim()) { documentId('category_id'); setCategoryErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_category}`); return }
        if (!editProduct.subcategory_id.trim()) { documentId('subcategory_id'); setSubcategoryErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_sub_category}`); return }
        setLoading(true)
        const images = await uploadImages()
        // product_type:'WAERABLE_PRODUCT',
        // product_type:'ELECTRONICS',
        const items = {
            _id: match?.params.id,
            name: editProduct.name,
            description: editProduct.description,
            brand_id: editProduct.brand_id,
            category_id: editProduct.category_id,
            subcategory_id: editProduct.subcategory_id,
            sub_subcategory_id: editProduct.sub_subcategory_id,
            images: [...images, ...editProduct.images],
            tax_percentage: Number(editProduct.tax_percentage),
            // quantity: Number(editProduct.quantity),
            price: Number(editProduct.price),
            discount_percantage: Number(editProduct.discount_percantage),
            variant_type: variantType || undefined,
            variant_value: variantType && variantValue ? {
                label: variantLabel,
                value: variantValue
            } : undefined,
            language: "ENGLISH"
        }
        try {
            let res = await henceforthApi.Product.editProduct(items)
            // console.log(res);
            toastMessage(res.message)
            setEditProduct({
                name: "",
                description: "",
                brand_id: "",
                category_id: "",
                subcategory_id: "",
                sub_subcategory_id: '',
                images: [],
                // quantity: '',
                price: "",
                discount_percantage: '',
                tax_percentage: '',
                sold: false,
                is_blocked: false,
                is_deleted: false,
                language: "ENGLISH"
            });
            // toastMessage(res.message)
            window.history.back();
        } catch (err: any) {
            // console.log(err);
            handleError(err, 'active', authDispatch);
        } finally {
            setLoading(false)
        }
    };

    const productDetails = async () => {
        setPageLoading(true)
        try {
            let productRes = (await henceforthApi.Product.getProductDetails(match?.params.id)).data
            setEditProduct({
                ...editProduct,
                name: productRes?.name,
                description: productRes?.description,
                brand_id: productRes?.brand_id?._id,
                category_id: productRes?.category_id?._id,
                subcategory_id: productRes?.subcategory_id?._id,
                sub_subcategory_id: productRes?.sub_subcategory_id?._id,
                tax_percentage: productRes?.tax_percentage,
                images: productRes?.images,
                // quantity: productRes?.quantity,
                price: productRes?.price,
                discount_percantage: productRes?.discount_percantage,
            })
            // Load variant data if exists
            if (productRes?.variant_type) {
                setVariantType(productRes.variant_type);
                if (productRes?.variant_value) {
                    setVariantLabel(productRes.variant_value.label || '');
                    setVariantValue(productRes.variant_value.value || '');
                }
            }
        } catch (err: any) {
            handleError(err, '', authDispatch);
            console.log(err.response);
        } finally {
            setPageLoading(false)
        }
    }
    useEffect(() => {
        productDetails()
    }, [])
    const imageRemove = (del: string, id: number) => {
        if (del) {
            editProduct.images.splice(id, 1)
            setEditProduct({
                ...editProduct,
            })
        } else {
            selectedFile.splice(id, 1)
            setSelectedFile([
                ...selectedFile,
            ])
        }
    }
    return (
        <Fragment>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />
            <div className='page-spacing'>
                {/* {!authState?.is_bank_added ? (
                    <section className='product-detail'>
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-md-6 mt-5">
                                    <div className="common-card text-center py-5">
                                        <div className="mb-4 text-warning">
                                            <i className="fa fa-exclamation-triangle fa-4x"></i>
                                        </div>
                                        <h4 className="mb-3">Bank Details Required</h4>
                                        <p className="text-muted mb-4">You need to add your bank details before you can edit products.</p>
                                        <Link to="/profile/bank-details" className="btn btn-theme px-5">
                                            <i className="fa fa-plus-circle me-1"></i> Add Bank Details Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : ( */}

                {pageLoading ? (
                    <div className='vh-100 d-flex justify-content-center py-5'>
                        <Spinner color={"text-success"} />
                    </div>
                ) : (
                    <section className='product-detail'>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    {/* Title  */}
                                    <div className="common-card">
                                        <div className="common-card-title">
                                            <h5>{language_data?.[authState.lang]?.common_edit} {language_data?.[authState.lang]?.common_product}</h5>
                                        </div>
                                        {/* Profile  */}
                                        <div className="common-card-content">
                                            <form onSubmit={handleSubmit}>

                                                <div className="upload-fields-box mb-3">
                                                    <label htmlFor="" className='fw-bolder mb-2'>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_images} *</label>
                                                    {/* Upload image */}

                                                    <div className="product-edit-image d-flex gap-2 gap-md-4 gap-lg-5 flex-column flex-sm-row">
                                                        <div className="product-edit-upload">
                                                            <div className='upload-fields-box mb-3'>
                                                                <div className='profile-edit-image mb-2 mx-0 product-edit-upload-image'>
                                                                    <div className='profile-edit-upload'>
                                                                        <input
                                                                            id="images"
                                                                            onChange={(e) => { setSelectedFileErr(''); handleFile(e) }}
                                                                            type="file"
                                                                            className={`form-control ${selectedFileErr ? 'is-invalid' : ''}`}
                                                                            accept='image/png,image/jpeg'
                                                                            multiple
                                                                        />
                                                                    </div>
                                                                    <img src={imageUpload} alt="img" className={` ${selectedFileErr ? 'border border-danger' : ''}`} />
                                                                </div>
                                                                <Errormessage phone={selectedFileErr} error={selectedFileErr} />
                                                            </div>
                                                        </div>
                                                        <div className='product-images-preview d-inline-flex gap-sm-4 gap-md-4 gap-lg-5 gap-3 flex-wrap flex-column flex-sm-row'>
                                                            {editProduct.images && editProduct.images.map((res, index: number) => {
                                                                return (
                                                                    <div key={index} className='preview-image-box position-relative'>
                                                                        <SignedImage
                                                                            className="Product-Images border border-light"
                                                                            src={res}
                                                                            alt={res}
                                                                            size="medium"
                                                                        />
                                                                        {editProduct.images[0] !== "" && <span key={Math.random()} className='preview-image-close ' onClick={() => imageRemove("del", index)}><i className='fa fa-close text-dark' style={{ cursor: 'pointer' }}></i> </span>}
                                                                    </div>
                                                                )
                                                            })}
                                                            {Array.isArray(selectedFile) ? selectedFile.map((res, index: number) => {

                                                                return (
                                                                    <div key={index} className='preview-image-box position-relative'><img
                                                                        className="Product-Images border border-light"
                                                                        src={URL.createObjectURL(res)} alt="img" />
                                                                        {<span key={Math.random()} className='preview-image-close ' onClick={() => imageRemove("", index)}><i className='fa fa-close text-dark' style={{ cursor: 'pointer' }}></i> </span>}
                                                                    </div>
                                                                )
                                                            }) : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                                <p><small><strong>{language_data?.[authState.lang]?.common_note}:-</strong>{language_data?.[authState.lang]?.common_please_upload_only_jpg_and_png_format_only}.</small></p>
                                                <div className='divider my-3'></div>
                                                {/* Product Name  */}
                                                <Inputs.Input type='text' id="productName" error={nameErr} label={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_name} *`} name='name' placeholder={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_name}`} value={editProduct.name} handleChange={handleChange} maxLength={100} />
                                                {/* Product Description  */}
                                                <Textarea error={descriptionErr} id="description" col={30} row={5} label={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_description} *`} name='description' placeholder={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_description}`} value={editProduct.description} handleChange={handleChange} maxLength={555} />
                                                {/* Product Price  */}
                                                <Inputs.Input type='text' id="price" error={priceErr} label={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_price} *`} name='price' placeholder={`${language_data?.[authState.lang]?.common_price}`} value={editProduct.price} handleChange={handleChange} maxLength={15} />
                                                {/* Product tax  */}
                                                <Inputs.Input type='text' error={taxErr} label={`${language_data?.[authState.lang]?.common_tax} ${language_data?.[authState.lang]?.common_percentage} % *`} name='tax_percentage' placeholder={`${language_data?.[authState.lang]?.common_tax} ${language_data?.[authState.lang]?.common_percentage}`} value={editProduct.tax_percentage} handleChange={handleChange} maxLength={3} />
                                                {/* Quantity */}
                                                {/* <Inputs.Input type='number' id="quantity" error={quantityErr} label={`${language_data?.[authState.lang]?.common_quantity} *`} name='quantity' placeholder={`${language_data?.[authState.lang]?.common_quantity}`} value={editProduct.quantity} handleChange={handleChange} maxLength={10} /> */}
                                                {/* Brand  */}
                                                <Select Array={brandDetails.brand} id="brand_id" error={brandErr} label={`${language_data?.[authState.lang]?.common_brand} *`} firstSelect='Brand' name='brand_id' value={editProduct.brand_id} handleChange={handleChange} />
                                                {/* Category-1  */}
                                                <Select Array={brandDetails.category} id="category_id" error={categoryErr} label={`${language_data?.[authState.lang]?.common_category_level} ${language_data?.[authState.lang]?._1} *`} firstSelect='Category' name='category_id' value={editProduct.category_id} handleChange={handleChange} />
                                                {/* Category-2  */}
                                                <Select Array={subCategory} disabled={!editProduct.category_id} error={subCategoryErr} label={`${language_data?.[authState.lang]?.common_category_level} ${language_data?.[authState.lang]?._2} *`} firstSelect='SubCategory' name='subcategory_id' value={editProduct.subcategory_id} handleChange={handleChange} />
                                                {/* Category-3  */}
                                                <Select Array={subSubCategory} disabled={!editProduct.subcategory_id} label={`${language_data?.[authState.lang]?.common_category_level} ${language_data?.[authState.lang]?._3}`} firstSelect='Sub_SubCategory' name='sub_subcategory_id' value={editProduct.sub_subcategory_id} handleChange={handleChange} />
                                                {/* Discount  */}
                                                <Inputs.Input type='number' label={`${language_data?.[authState.lang]?.common_discount}`} name='discount_percantage' placeholder={`${language_data?.[authState.lang]?.common_enter} ${language_data?.[authState.lang]?.common_your} ${language_data?.[authState.lang]?.common_discount}}`} value={editProduct.discount_percantage} handleChange={handleChange} />
                                                {/* <Select Array={commonArray?.discount} label='Discount' firstSelect='Discount' name='discount_percantage' value={editProduct.discount_percantage} handleChange={handleChange} /> */}
                                                <div className="divider my-3"></div>
                                                {/* Variants */}
                                                <h5 className="fw-bolder mb-3">
                                                    {language_data?.[authState.lang]?.common_variant || "Variant"} ({language_data?.[authState.lang]?.common_optional || "Optional"})
                                                </h5>

                                                <div className="row">

                                                    {/* TYPE */}
                                                    <div className="col-md-4">
                                                        <Select
                                                            Array={[
                                                                { _id: "COLOR", name: "Color" },
                                                                { _id: "SIZE", name: "Size" }
                                                            ]}
                                                            label="Variant Type"
                                                            firstSelect="Select Type"
                                                            name="variantType"
                                                            value={variantType}
                                                            handleChange={(e: any) => {
                                                                setVariantType(e.target.value);
                                                                setVariantValue('');
                                                                setVariantLabel('');
                                                                setVariantErr('');
                                                            }}
                                                        />
                                                    </div>

                                                    {/* COLOR UI */}
                                                    {variantType === "COLOR" && (
                                                        <>
                                                            <div className="col-md-2">
                                                                <label className="form-label">Color</label>
                                                                <input
                                                                    type="color"
                                                                    className="form-control form-control-color w-100 m-0 "
                                                                    value={variantValue || "#000000"}
                                                                    onChange={(e) => setVariantValue(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-md-6">
                                                                <Inputs.Input
                                                                    type="text"
                                                                    label="Color Name"
                                                                    name="variantLabel"
                                                                    placeholder="e.g. Red, Sky Blue"
                                                                    value={variantLabel}
                                                                    handleChange={(e: any) => setVariantLabel(e.target.value)}
                                                                />
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* SIZE UI */}
                                                    {variantType === "SIZE" && (
                                                        <>
                                                            <div className="col-md-4">
                                                                <Inputs.Input
                                                                    type="text"
                                                                    label="Label"
                                                                    name="variantLabel"
                                                                    placeholder="Small, Medium"
                                                                    value={variantLabel}
                                                                    handleChange={(e: any) => setVariantLabel(e.target.value)}
                                                                    maxLength={50}
                                                                />
                                                            </div>

                                                            <div className="col-md-4">
                                                                <Inputs.Input
                                                                    type="text"
                                                                    label="Value"
                                                                    name="variantValue"
                                                                    placeholder="S, M, L"
                                                                    value={variantValue}
                                                                    handleChange={(e: any) => setVariantValue(e.target.value)}
                                                                    maxLength={50}
                                                                />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                {/* ERROR */}
                                                {variantErr && <Errormessage error={variantErr} />}

                                                {/* PREVIEW */}
                                                {variantType && variantValue && (
                                                    <div className="common-card mt-3 p-3">
                                                        <div className="d-flex align-items-center gap-3">

                                                            <strong>{variantType}:</strong>

                                                            {variantType === "COLOR" ? (
                                                                <>
                                                                    <span>{variantLabel || "No Name"}</span>
                                                                    <span
                                                                        style={{
                                                                            background: variantValue,
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            borderRadius: "50%",
                                                                            border: "1px solid #ddd"
                                                                        }}
                                                                    />
                                                                </>
                                                            ) : (
                                                                <span>{variantLabel} ({variantValue})</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="divider my-3"></div>
                                                {/* Buttons  */}
                                                <SaveCancelButton loading={loading} color="text-white" onClick={handleSubmit} />
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}


            </div>
        </Fragment>
    )
}
export default EditProduct;